import { apiProxyRequest } from "Api/apiProxyRequest";

import type { PaymentIntentResponse } from "../types";

export const createPaymentIntentRequest = (billingProfileId: string) => {
  return apiProxyRequest<PaymentIntentResponse>(
    `/billing/profiles/${billingProfileId}/payment-source/intent`,
    "POST"
  );
};
